import { Box, BoxProps, Image, useColorModeValue } from "@chakra-ui/react";
import GreenLogoSvg from "../../assets/logo-full-green.svg";
import WhiteLogoSvg from "../../assets/logo-full-white.svg";

interface IProps extends BoxProps {
  image?: any;
}

const LogoContainer = (props: IProps) => {
  return (
    <Box {...props}>
      <Image h="full" src={props.image} />
    </Box>
  );
};

const LogoBase = (props: BoxProps) => {
  const imagePng = useColorModeValue(GreenLogoSvg, WhiteLogoSvg);

  return <LogoContainer image={imagePng} {...props}></LogoContainer>;
};

const LogoWhite = (props: BoxProps) => {
  return <LogoContainer image={WhiteLogoSvg} {...props}></LogoContainer>;
};
const LogoGreen = (props: BoxProps) => {
  return <LogoContainer image={GreenLogoSvg} {...props}></LogoContainer>;
};

const LogoContrast = (props: BoxProps) => {
  const imagePng = useColorModeValue(WhiteLogoSvg, GreenLogoSvg);

  return <LogoContainer image={imagePng} {...props}></LogoContainer>;
};

export const Logo = {
  Base: LogoBase,
  White: LogoWhite,
  Green: LogoGreen,
  Contrast: LogoContrast,
};
